<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>患者名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>联系方式:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.phone'></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker type='daterange' :maxlength='100' placeholder='请输入' class="item"
              clearable v-model.trim='query.duration'></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>注册方式:</label>
            <lk-select v-model="query.registerType" placeholder='请选择' class="item" clearable>
              <lk-option v-for="(item,i) in registerTypeList" :value='i' :key="i">{{item}}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>创建门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.createStoreIdList'></StoreListSelect>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>购药门店:</label>
            <StoreListSelect :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.buyStoreIdList'></StoreListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">
          <DownloadButton @on-click="download" v-if="handlePermission('patientExport')">
          </DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

    <!-- 药历打印start -->
    <section id="printArea" ref="print" class="print-area">
      <table class="print-table">
        <tbody>
          <tr>
            <th colspan="9" style="height: 40px;">
              <h3>患者药历</h3>
            </th>
          </tr>
          <tr>
            <td colspan="9">
              <span class="mr32">患者姓名：{{printInfo.name}}</span>
              <span class="mr32">性别：{{printInfo.gender}}</span>
              <span class="mr32">年龄：{{printInfo.age}}</span>
              <span class="mr32">联系方式：{{printInfo.phone}}</span>
            </td>
          </tr>
          <div v-for="(item, index) in printInfo.taskVos" :key="index">
            <tr>
              <td colspan="9">
                <span style="color: #327eff;font-weight: 500;">销售订单：{{item.orderCode}}</span>
              </td>
            </tr>
            <tr>
              <td style="width: 15%;font-weight: 500;">通用名</td>
              <td style="width: 12%;font-weight: 500;">商品名</td>
              <td style="width: 12%;font-weight: 500;">规格</td>
              <td style="width: 8%;font-weight: 500;">数量</td>
              <td style="width: 12%;font-weight: 500;">用法</td>
              <td style="width: 10%;font-weight: 500;">频次</td>
              <td style="width: 10%;font-weight: 500;">每次用量</td>
              <td style="width: 12%;font-weight: 500;">开始用药时间</td>
              <td style="width: 9%;font-weight: 500;">用药周期</td>
            </tr>
            <tr v-for="(drug, drugIndex) in item.saleUsageList" :key="drugIndex">
              <!-- 通用名 -->
              <td style="max-width: 130px;"><div class="ivu-table-cell"><span>{{drug.approvedDrugNames}}</span></div></td>
              <!-- 商品名 -->
              <td style="max-width: 120px;"><div class="ivu-table-cell"><span>{{drug.goodsName}}</span></div></td>
              <!-- 规格 -->
              <td><span>{{drug.spec}}</span></td>
              <!-- 数量 -->
              <td><span>{{drug.goodsCount}}</span></td>
              <!-- 用法 -->
              <td><span>{{drug.goodsUsage}}</span></td>
              <!-- 频次 -->
              <td><span>{{drug.frequencyName}}</span></td>
              <!-- 每次用量 -->
              <td><span>{{drug.goodsDosage}}</span></td>
              <!-- 开始用药时间 -->
              <td><span>{{drug.usageStartTime}}</span></td>
              <!-- 用药周期 -->
              <td><span>{{drug.medicationCycle}}</span></td>
            </tr>
            <div v-for="(task, taskIndex) in item.interviewDetails" :key="taskIndex">
              <tr>
                <td rowspan="2"><span style="font-weight: 500;">随访任务{{task.taskId}}</span></td>
                <td colspan="8">
                  <span class="mr32">预约随访时间：{{task.interviewTime}}</span>
                  <span class="mr32">呼叫情况：{{task.interviewStatus}}</span>
                  <span class="mr32">备注：{{task.remark}}</span>
                </td>
              </tr>
              <tr>
                <td colspan="9">
                  <div style="display: flex;flex-direction: row;flex-wrap: wrap;">
                    <span class="mr32" style="color: #ebebeb;" v-if="!task.formList || task.formList.length === 0">--</span>
                    <span v-else class="mr32" v-for="formItem in task.formList" :key="formItem.key">{{formItem.title}}：{{formItem.value}}</span>
                  </div>
                </td>
              </tr>
            </div>
          </div>
        </tbody>
      </table>
      <p class="page-break"></p>
    </section>
    <!-- 药历打印end -->
  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../services/supplier';
import base from '../../../services/base';
// import DtpDatePicker from '../../components/DtpDatePicker.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import DownloadButton from '../../../components/download/DownloadButton';
// import location from '../../../components/location';

// const { hospital } = base;
export default {
  name: 'PatientList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    // location,
  },
  data() {
    return {
      registerTypeList: {
        1: '处方创建',
        2: '邻客智慧药房公众号',
        3: '邻客健康管家',
        4: '用药咨询',
      },

      columns: [
        {
          title: '患者姓名',
          key: 'name',
          minWidth: 116,
        },
        {
          title: '性别',
          key: 'gender',
          minWidth: 116,
        },
        {
          title: '联系方式',
          key: 'phone',
          minWidth: 116,
        },

        {
          title: '出生年月',
          key: 'birthday',
          minWidth: 116,
        },
        {
          title: '证件类型',
          key: 'permissionTypeStr',
          minWidth: 116,
        },
        {
          title: '证件号码',
          key: 'idCard',
          minWidth: 116,
        },

        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '注册方式',
          key: 'registerTypeName',
          minWidth: 116,
        },

        {
          title: '购药门店',
          key: 'buyStoreNames',
          minWidth: 116,
        },
        {
          title: '创建门店',
          key: 'createStoreName',
          minWidth: 116,
        },
        // {
        //   title: '进行中的任务',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },
        // {
        //   title: '创建门店',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },
        // {
        //   title: '创建门店',
        //   key: 'createStoreName',
        //   minWidth: 116,
        // },


        {
          title: '操作',
          key: 'action',
          width: 200,
          fixed: 'right',
          render: (h, params) => h('div', [
            (this.handlePermission('patientCheck') ? h(
              'lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'patientCheck', params: { id: params.row.id } });
                  },
                },
              }, '查看',
            ) : null), (this.handlePermission('patientEdit') ? h(
              'lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({ name: 'patientEdit', params: { id: params.row.id } });
                  },
                },
              }, '编辑',
            ) : null), (this.handlePermission('printPatientRecord') ? h(
              'lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.getPrintData(params.row.id);
                  },
                },
              }, '打印患者药历',
            ) : null),
          ]),
        },
      ],


      query: {
        duration: [],
      },

      tableData: [],

      printInfo: {},

    };
  },
  methods: {

    download() {
      const params = this.formatParams(this.params);
      params.page = 0;
      params.size = 0;
      delete params.encrypt;
      // params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      // delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.type = 2;
      base.patient.downloadPatientList(params).then((res) => {
        // utils.downLoadExcel(res, '处方药销售记录查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    clear() {
      this.query = {
        duration: [],
      };
    },
    formatParams(params) {
      const temp = utils.deepClone(params);
      temp.page = this.page;
      temp.size = this.size;
      if (temp.duration.length) {
        temp.createTimeStart = temp.duration[0];
        temp.createTimeEnd = temp.duration[1];
      }
      return temp;
    },
    getData() {
      // this.params.page = this.page;
      // this.params.size = this.size;

      this.params = this.formatParams(this.query);
      this.params.encrypt = true;
      base.patient.getPatientList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = utils.deepClone(item.patient);
            // result.proceedsAmount = item.proceedsAmount;
            console.log(item);

            result.gender = this.publicParams.genderList[result.gender];
            result.createTime = utils.formatTime(result.createTime);
            result.birthday = utils.formatDate(result.birthday);
            result.buyStoreNames = item.buyStoreNames;

            result.permissionTypeStr = this.$store.getters.getCredentialsTypeStr(item.patient.permissionType);
            // result.paymentStatusString = this.publicParams.judgeList[result.paymentStatus];
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },

    getInterviewFromList(layout, params) {
      if (!layout || !params) {
        return;
      }
      layout = JSON.parse(layout);
      params = JSON.parse(params);
      const list = [];
      layout.forEach((item) => {
        if (params[item.key]) {
          if (item.data && item.data.options) {
            if (typeof params[item.key] === 'string') {
              const optionItem = item.data.options.find(option => option.value == params[item.key]);
              item.value = optionItem ? optionItem.label : params[item.key];
            } else if (Array.isArray(params[item.key])) {
              const valueList = params[item.key].map((option) => {
                const op = item.data.options.find(child => option == child.value);
                if (op && op.label) {
                  return op.label;
                }
              });
              item.value = valueList ? valueList.join('、') : '';
            }
          } else {
            item.value = params[item.key];
          }
          if (item.value) {
            list.push(item);
          }
        }
      });
      return list;
    },

    getPrintData(patientId) {
      base.patient.getPatientInterviewRecordList({ patientId }).then((res) => {
        if (res.data.status === 200 && res.data.data) {
          const data = res.data.data;
          data.gender = this.publicParams.genderList[data.gender];
          data.taskVos.forEach((item) => {
            item.saleUsageList.forEach((child) => {
              child.usageStartTime = utils.formatTime(child.usageStartTime, 'YYYY-MM-DD');
            });
            item.interviewDetails.forEach((child) => {
              child.interviewStatus = child.interviewStatus == 1 ? '接通' : '未接通';
              child.interviewTime = utils.formatTime(child.interviewTime);
              child.formList = this.getInterviewFromList(child.templateContent, child.templateResult);
            });
          });
          this.printInfo = data;
          this.$nextTick(() => {
            this.$print(this.$refs.print);
          });
        } else {
          this.$Message.error(res.data.error || '数据异常');
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    // addNew() {
    //   this.$router.push({
    //     name: 'supplierGeneralAdd',
    //   });
    // },

  },
  mounted() {
    // this.getNation();
    // this.getSourceList();
    this.handleSearch(true);
    if (this.roleType === 2) {
      this.columns.splice(7, 2);
    }
  },
};

</script>

<style lang="less" scoped>

@media print {
    .print-area {
      display: block;
    }
    .page-break {
      page-break-after: always;
    }
  }
  @media screen {
    .print-area {
      display: none;
    }
  }
  .mr32{
    margin-right: 32px;
    line-height: 20px;
  }
  .print-table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    border-spacing: 0;
    td,
    th {
      padding: 5px;
      border: 1px solid;
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
    }
    thead {
      th,
      td {
        padding: 5px;
        font-size: 12px;
        font-weight: normal;
        text-align: left;
      }
    }
    tbody {
      td {
        font-size: 12px;
        text-align: left;
        padding: 5px;
        span {
          font-size: 12px;
          word-break: break-all;
          &.small {
            transform: scale(0.6) translateX(0);
          }
        }
      }
    }
    .range {
      display: inline-block;
      min-width: 50px;
      max-width: 160px;
      white-space: nowrap;    /* 先设置为强制不换行 */
      text-overflow: ellipsis;    /* 超出设为为省略号 */
      overflow: hidden;           /* 超出隐藏 */
    }
    .text-right {
      padding-right: 8px;
      text-align: right;
    }
    .text-center {
      padding-right: 8px;
      text-align: center;
    }
    .ivu-table-cell {
      padding: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
  }

</style>
